 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"auth~editor":"auth~editor","auth~my-area":"auth~my-area","auth":"auth","my-area":"my-area","admin":"admin","editor":"editor","testimonials":"testimonials","china":"china"}[chunkId]||chunkId) + "-legacy." + {"chunk-026ee61a":"2ae1bb2e","chunk-61011354":"414b2e7b","auth~editor":"3dd217e9","auth~my-area":"9e4715c0","auth":"68f12fd7","my-area":"3917a74d","chunk-0497e47b":"476f6863","chunk-15fac1fc":"d1760e9c","chunk-4f6becdd":"8ade376b","chunk-7576ef57":"2bfc17c0","chunk-2d3f4ac6":"5657efad","chunk-2146fe94":"8f755e29","chunk-2f153d73":"835f3ff1","chunk-77e0a2d1":"818f9c3f","chunk-5a4f58d8":"b0b3c615","chunk-71de1d3c":"802c4b51","chunk-042b1956":"c3d1c82b","admin":"bfe167f2","chunk-0e565024":"c9642e35","chunk-43e8e4b7":"427aae14","chunk-211cb2cc":"476ff8f2","chunk-68bd375a":"a04122ee","chunk-7abfcf06":"368e4f9c","chunk-1b874172":"42e14337","chunk-a3b1bf36":"7471fdde","chunk-0b21e0ba":"56d79ac1","chunk-689a101d":"2ea93d46","chunk-17a39fdc":"f342afb4","chunk-2d0d6b32":"2a258de7","chunk-2d0e5e97":"63c247d9","chunk-2d20ef97":"bf2d9870","chunk-2d2223b5":"0252f76b","chunk-6196d087":"ced7e638","chunk-e7fbc602":"e1a8bde2","chunk-2fa0a623":"550ccb82","chunk-387159c3":"e364dcfa","chunk-5a2afc36":"d68f15d6","chunk-5f69d756":"1f6c8431","chunk-721962b2":"b2c8859a","chunk-2d21a3d2":"a8dab8c0","chunk-4828712e":"59263b21","chunk-7e11e666":"1225d027","chunk-650b978f":"5d311dae","chunk-68fff302":"c6c124d2","chunk-78db6d54":"fa5b637b","chunk-7e4b07a9":"e3a7cea5","chunk-957278c2":"809a1cdf","chunk-98cbb854":"d4e142df","chunk-a05f719e":"5656177e","chunk-b65c143e":"b7dfff10","chunk-bedd4c80":"2d229c38","chunk-e2550c26":"95b51f34","chunk-4b01205a":"d8bbf7d5","chunk-5eff3d57":"f76fadc4","chunk-f7a56554":"c8bce4b7","chunk-ea33e1c0":"6f52f74c","chunk-ec2f7a78":"73a228f1","editor":"31c487d3","chunk-e1810938":"b3f6d33e","testimonials":"b2630e58","chunk-2cf1c3bc":"e1cfbf33","china":"106fa27b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-61011354":1,"auth~my-area":1,"auth":1,"my-area":1,"chunk-0497e47b":1,"chunk-15fac1fc":1,"chunk-4f6becdd":1,"chunk-7576ef57":1,"chunk-2d3f4ac6":1,"chunk-2146fe94":1,"chunk-2f153d73":1,"chunk-77e0a2d1":1,"chunk-5a4f58d8":1,"chunk-042b1956":1,"admin":1,"chunk-0e565024":1,"chunk-43e8e4b7":1,"chunk-211cb2cc":1,"chunk-68bd375a":1,"chunk-7abfcf06":1,"chunk-1b874172":1,"chunk-a3b1bf36":1,"chunk-0b21e0ba":1,"chunk-689a101d":1,"chunk-17a39fdc":1,"chunk-6196d087":1,"chunk-e7fbc602":1,"chunk-2fa0a623":1,"chunk-387159c3":1,"chunk-5a2afc36":1,"chunk-5f69d756":1,"chunk-721962b2":1,"chunk-4828712e":1,"chunk-7e11e666":1,"chunk-650b978f":1,"chunk-68fff302":1,"chunk-78db6d54":1,"chunk-7e4b07a9":1,"chunk-957278c2":1,"chunk-98cbb854":1,"chunk-a05f719e":1,"chunk-b65c143e":1,"chunk-bedd4c80":1,"chunk-e2550c26":1,"chunk-4b01205a":1,"chunk-5eff3d57":1,"chunk-f7a56554":1,"chunk-ea33e1c0":1,"chunk-ec2f7a78":1,"editor":1,"chunk-e1810938":1,"testimonials":1,"chunk-2cf1c3bc":1,"china":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"auth~editor":"auth~editor","auth~my-area":"auth~my-area","auth":"auth","my-area":"my-area","admin":"admin","editor":"editor","testimonials":"testimonials","china":"china"}[chunkId]||chunkId) + "." + {"chunk-026ee61a":"31d6cfe0","chunk-61011354":"efdd6975","auth~editor":"31d6cfe0","auth~my-area":"d1ea3edb","auth":"1cf2ec8a","my-area":"16a3c839","chunk-0497e47b":"947795e8","chunk-15fac1fc":"621ac5b9","chunk-4f6becdd":"2ee696de","chunk-7576ef57":"84685266","chunk-2d3f4ac6":"66fd4e8e","chunk-2146fe94":"b5b21cb6","chunk-2f153d73":"dbb672ff","chunk-77e0a2d1":"ebcf84a6","chunk-5a4f58d8":"bbf156e9","chunk-71de1d3c":"31d6cfe0","chunk-042b1956":"045bbb6b","admin":"b40203fe","chunk-0e565024":"7e2d46f0","chunk-43e8e4b7":"9accd333","chunk-211cb2cc":"62e4bafa","chunk-68bd375a":"be6d7d32","chunk-7abfcf06":"44f9d81d","chunk-1b874172":"e3964b59","chunk-a3b1bf36":"940931a8","chunk-0b21e0ba":"b0c2fcec","chunk-689a101d":"789457b1","chunk-17a39fdc":"dbb53152","chunk-2d0d6b32":"31d6cfe0","chunk-2d0e5e97":"31d6cfe0","chunk-2d20ef97":"31d6cfe0","chunk-2d2223b5":"31d6cfe0","chunk-6196d087":"679783e5","chunk-e7fbc602":"69268946","chunk-2fa0a623":"1d47157c","chunk-387159c3":"47f27e3b","chunk-5a2afc36":"21da923f","chunk-5f69d756":"48ebb0a1","chunk-721962b2":"43afe4ce","chunk-2d21a3d2":"31d6cfe0","chunk-4828712e":"54570902","chunk-7e11e666":"7e88533d","chunk-650b978f":"2c2b4fb4","chunk-68fff302":"babc3a1d","chunk-78db6d54":"29fb89fc","chunk-7e4b07a9":"6cbe2724","chunk-957278c2":"76a5a113","chunk-98cbb854":"a888543d","chunk-a05f719e":"29fb89fc","chunk-b65c143e":"29fb89fc","chunk-bedd4c80":"29fb89fc","chunk-e2550c26":"5af63147","chunk-4b01205a":"acd62d90","chunk-5eff3d57":"ef73b2ad","chunk-f7a56554":"966d7686","chunk-ea33e1c0":"81aaa093","chunk-ec2f7a78":"a6491283","editor":"1fb02e7d","chunk-e1810938":"833cd6ce","testimonials":"9d31ac9f","chunk-2cf1c3bc":"8e963ab9","china":"6fef1961"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
